const uniKey = (object: any): string => {
  return Object.entries(object)
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([k, v]) => {
      if (typeof v === 'object') {
        return `${k}:{${uniKey(v)}}`
      }
      if (typeof v === 'string') {
        return `${k}:"${v}"`
      }
      return `${k}:${v}`
    })
    .join(',')
}

const promiseMap = new Map<string, Promise<any>>()

export const lockPromiseFn = <Fn extends (...args: any[]) => Promise<any>>(fn: Fn) => {
  return (...args: Parameters<Fn>): ReturnType<Fn> => {
    const key = `${fn.name}(${uniKey(args)})`
    if (!promiseMap.has(key)) {
      promiseMap.set(
        key,
        fn(...args).finally(() => {
          promiseMap.delete(key)
        })
      )
    }
    return promiseMap.get(key) as any
  }
}
